<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"  @close="close">
    <!-- 所属用户 -->
    <el-form  :rules="rules" ref="ruleForm"  :model="form" label-width="100px" >
      <el-form-item label="标题" prop="name">
        <el-input v-model.trim="form.name" ></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
            <el-radio :label="1">纸箱</el-radio>
            <el-radio :label="2">快递袋</el-radio>
            <el-radio :label="3">物品加固</el-radio>
          </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
   MonadCarton_update, //新用户添加修改
   MonadCarton_detail, //详情
  } from '@/api/new_user.js'

  export default {
    name: 'UserManagementEdit',
    data() {
      return {
        dialogFormVisible: false,
        form: {
         "id": "", //id
         "name": "", //用户名
         "type": "" //1纸箱 2快递单 3物品加固
        },
        rules:{
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          type: [{ required: true, message: '请选则类型', trigger: ['blur' , 'change'] }],
        },
        title: '',
        listInfo: [],
        brandList: [],
      }
    },

    created() {},
    methods: {

      // 获取详情数据
      showEdit(row) {
        if(row){
          // 编辑
          this.title = '编辑纸箱'
          var data = {
            id:row.id
          }
          MonadCarton_detail(data).then(res=>{
            this.form = res.data
            this.dialogFormVisible = true
          })
        }else{
          //新增用户
          this.title = '新增纸箱'
          this.dialogFormVisible = true
        }
      },

      // 点击关闭弹窗
      close() {
        this.dialogFormVisible = false
        this.form = {
          id:null,
         "name": "", //用户名
         "type": "" //1纸箱 2快递单 3物品加固
        }
      },
      // 点击提交更改
      save() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            var address = []
            var data = {
              id:this.form.id?this.form.id:null,
              "name": this.form.name, //用户名
              "type": this.form.type //1纸箱 2快递单 3物品加固
            }
            MonadCarton_update(data).then(res=>{
              this.close()
              this.$emit('formChange' , true)
              this.$message({
                type:'success',
                message:'操作成功'
              })
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
    },
  }
</script>
<style scoped>
  .black {
    font-weight: bold;
    color: #000000;
  }

  .xinxi {
    border: 1px solid #dcdfe6;
    margin-bottom: 5px;
    padding: 10px;
    box-sizing: border-box;
  }
</style>
